import React, { memo, useEffect, useState } from 'react'
import { imgUrlConverter, actionUrlConverter } from '../../util'

const CatalogBrowseGroupTiles = ({ appData:{pageContentData}, appData:{catalogBrowseData} }) => {
    const [catalogGroupData, setCatalogGroupData] = useState([])
    const catalogBrowseGroupTiles = pageContentData?.find(data => data.contentType === "catalogBrowseGroupTiles")

    useEffect(() => {
        const catalogGroupArray = []
        Object.keys(catalogBrowseData) && Object.keys(catalogBrowseData).length > 0 && Object.keys(catalogBrowseData).forEach((catalogData) =>
            catalogBrowseData[catalogData]?.productGroups && Object.keys(catalogBrowseData[catalogData]?.productGroups).length > 0 && Object.keys(catalogBrowseData[catalogData]?.productGroups).forEach((objKey) =>
                catalogData?.split("-")?.length === 3 &&
                catalogGroupArray.push(catalogBrowseData[catalogData].productGroups[objKey])
            ))
        setCatalogGroupData(catalogGroupArray)
    }, [catalogBrowseData])

    if(catalogBrowseGroupTiles){
        return <div className="row mx-1 browse-group pro-champ-group-override">
            {
                catalogGroupData?.length > 1 && catalogGroupData.sort((a, b) => a.orderSeq - b.orderSeq)?.map((categoryObj) => {
                    let foundInPageContext = false
                    return (<>
                        {categoryObj.imageKeys?.map((imgKey) => (
                            catalogBrowseGroupTiles?.images?.map((image) => {
                                if (image.groupOsr === imgKey) {
                                    foundInPageContext = true
                                    //return <span className="mr-3"><img rel="preload" height="50" width="50" src={imgUrlConverter(image.imageUrl)} alt="Banner background" /><span>{categoryObj?.displayName}</span><i className="fas fa-chevron-right"></i></span>
                                    return <div className="col-xl-2 col-lg-2 col-md-3 col-sm-6 col-xs-6 col-6 p-3 group-tile"><a href={actionUrlConverter(categoryObj?.actionUrl)}><img rel="preload" height="40" width="40" src={imgUrlConverter(image.imageUrl)} alt="Group_Tiles" /><div><strong className="mr-3">{categoryObj?.displayName}</strong><i className="fas fa-chevron-right"></i></div></a></div>
                                }
                                return true
                            })
                        ))}
                        {/* {(!foundInPageContext) && <span className="mr-3"><img rel="preload" height="50" width="50" src={imgUrlConverter(categoryObj?.imageUrl)} alt="Banner background" /><span>{categoryObj?.displayName}</span><i className="fas fa-chevron-right"></i></span>} */}
                        {(!foundInPageContext) && <div className="col-xl-2 col-lg-2 col-md-3 col-sm-6 col-xs-6 col-6 p-3 group-tile"><a href={actionUrlConverter(categoryObj?.actionUrl)}><img rel="preload" height="40" width="40" src={imgUrlConverter(categoryObj?.imageUrl)} alt="Group_Tiles" /> <div><strong className="mr-3">{categoryObj?.displayName}</strong><i className="fas fa-chevron-right"></i></div></a></div>}
                    </>

                    )
                }
                )
            }
        </div>
    }else{
        return null
    }
}

export default memo(CatalogBrowseGroupTiles)
